module.exports = __webpack_public_path__ + "static/img/scott-billy.d6335b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scott-billy.jpg
// module id = FYED
// module chunks = 0